/**
 * @author xyguo
 * @description 新开业培训要求记录管理
 * @Date 2021/3/16
 */
import React from 'react';
import {connect} from 'dva';
import {templateConfig, reduxTemplateCofig} from './config';
import {requirementBaseExcelColumns,requirementEXTExcelColumns,requirementEndExcelColumns} from "./excelColumns";

import {framework_tool, component_tool, utils_tool} from '@/tool'
import LookPositionAuthState from './lookPositionAuthState';

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizCol, WizRow,WizModal} = component_tool;
let {checkStrLength, Session} = utils_tool;
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterType = (val) => {
  let newVal;
  switch (val) {
    case  1 :
      newVal = '4S网点'
      break;
    case  2 :
      newVal = '直营店'
      break;
    case  3 :
      newVal = '单一售后'
      break;
    case  4 :
      newVal = '单一销售'
      break;
    case  5 :
      newVal = '卫星店/直营店'
      break;
    case  6 :
      newVal = '自修站'
      break;
    case  7 :
      newVal = '卫星店'
      break;
    case  8 :
      newVal = '精品店'
      break;
    case  9 :
      newVal = 'dealer'
      break;
    case  10 :
      newVal = '4S店'
      break;
    case  11:
      newVal = '汽车零售'
      break;
    case  12 :
      newVal = '单一销售展厅'
      break;
    case  13 :
      newVal = 'NEV单一售后'
      break;
    case  14 :
      newVal = '轻量化4S网点'
      break;
    case  15 :
      newVal = 'NEV专区'
      break;
    case  16 :
      newVal = '商超店'
      break;
    case 17:
      newVal = '自修店'
      break;
    case 18:
      newVal = '二级网点'
      break;
    case 19:
      newVal = '车工坊C1'
      break;
    case 20:
      newVal = '车工坊C2'
      break;
    case 21:
      newVal = '车工坊B'
      break;
    case 22:
      newVal = '德科品牌授权经销商'
      break;
    case 99:
      newVal = '暂定'
      break;
    default :
      newVal = '无';
  }
  return newVal;
}

const formatterState = (val) => {
  if(val == null || val == undefined || val == -1){
    return "";
  }
  let newVal;
  switch (val) {
    case 0 :
      newVal = "● 合格"
      break;
    case 1 :
      newVal = "● 不合格"
      break;
    case 3 :
      newVal = "○"
      break;
    case 4 :
      newVal = ""
      break;
  }
  return newVal;
}

const formatterDealerState = (val) => {
  let newVal;
  switch (val){
    case 0 : newVal = "培训中"
      break
    case 1 : newVal = "已完成"
      break
    case 2 : newVal = "达标确认"
      break
    case 3 : newVal = "人员有变更，请重新确认"
      break
    case 4 : newVal = "已开店达标确认"
      break
    case 5 : newVal = "已开店未达标"
      break
    default:
      newVal = ''
  }
  return newVal;
}

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    //查看
    if (history.location.pathname === '/requirementPersonnel/requirementPersonnelList/requirementPersonnelDetailList') {
      if (history.location && history.location.record) {
        record = history.location.record
        record.typeName = formatterType(record.type);
        Session.set('requirementPersonnelDetail', record);
      } else if (Session.get('requirementPersonnelDetail')) {
        record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      }
    } else if (history.location.pathname === '/dealerNewPersonTrain/dealerNewPersonTrainList/requirementPersonnelDetailList') {
      if (history.location && history.location.record) {
        let dealerNewPersonTrainInfo = history.location.record;
        record = dealerNewPersonTrainInfo && dealerNewPersonTrainInfo.requirementPersonnelEntity;
        record.typeName = formatterType(record.type);
        Session.set('requirementPersonnelDetail', record);
      } else if (Session.get('requirementPersonnelDetail')) {
        record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      }
    }
  }else {
    record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
  }
  return record
}

class RequirementPersonnelDetailList extends WizContainer {

  componentName = 'RequirementPersonnelDetailList';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue=getParamRecord(history)
    log.info('requirementPersonnelEntity---',initialValue);
    this.state = {
      trainState: initialValue.state,
      scoreVisable: false,
      lookRecord:{},
      headList:[],
    }
    this.initialValue = initialValue;
  }

  _handleCMD = (nextProps, nextState, key) => {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      this.setState({
        trainState: 2
      })
      let record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      record.state = 2
      Session.set('requirementPersonnelDetail', record);
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    let columnDefs =  [...requirementBaseExcelColumns];
    if(this.state.headList && this.state.headList.length){
      this.state.headList.forEach(element => {
        let requirementType = element.requirementType;
        requirementEXTExcelColumns.forEach(e=>{
          if(e.requirementType==requirementType){
            e.headerName = element.showTitle
            columnDefs.push(e);
          }
        })
      });
    }
    columnDefs = [...columnDefs,...requirementEndExcelColumns]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e.onlineState =  formatterState(e.onlineState);
        e.certState = formatterState(e.certState);
        e.offlineState = formatterState(e.offlineState);
        e.personnelState = formatterState(e.personnelState);
        e.resumeState = formatterState(e.resumeState);
        e.mbtiState = formatterState(e.mbtiState);
        e.interviewState = formatterState(e.interviewState);
        e.electricCertState = formatterState(e.electricCertState);
        e.positionAuthState = formatterState(e.positionAuthState);
        e.onlineExamState =  formatterState(e.onlineExamState);
        e.benchmarkState =  formatterState(e.benchmarkState);
      })

      let record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      let title = '经销商名称：' + record.dealerName + '\n'
        + '品牌：' + record.brandName + '\n'
        + '预估开业时间：' + formatterDate(record.openTime) + '\n'
        + '开店时间：' + formatterDate(record.dealerOpenTime) + '\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '站点类型：' + record.typeName;

      WizBrowserExport({
        title: title,
        sheetName: '新开业人员培训详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新开业人员培训详情.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 105
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _showTitle(record) {
    let content = <WizCard title={'经销商信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={8} offset={2}>
          经销商名称: {record.dealerName}
        </WizCol>
        <WizCol span={6}>
          品牌: {record.brandName}
        </WizCol>
        <WizCol span={8}>
          站点类型: {record.typeName}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          销售代码: {record.preSalesNumber}
        </WizCol>
        <WizCol span={6}>
          售后代码: {record.afterSalesNumber}
        </WizCol>
        <WizCol span={8}>
          预估开业时间: {formatterDate(record.openTime)}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          开店时间: {formatterDate(record.dealerOpenTime)}
        </WizCol>
        <WizCol span={6}>
          完成时间: {formatterMinute(record.completeTime)}
        </WizCol>
        <WizCol span={8}>
          状态: {formatterDealerState(record.state)}
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _handleHeadListData=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    if (o['success']) {
      this.setState({
        headList: o.data
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let record = this.initialValue;
    const {type} = record;
    let _reduxTemplateCofig = reduxTemplateCofig({
      record,
      templateConfig: templateConfig(this.state.trainState, type,this,record,this.state.headList),
      apiDataFormat: {
        export: this._handleFile,
        dealerConfirm: this._handleCMD,
        headList: this._handleHeadListData,
      },
      keepInitApiParams: true,
    })
    //footer={null}
    return <>{this._showTitle(record)}
      <WizCard title={'新开业人员培训详情'}>
        <WizReduxTemplate {..._reduxTemplateCofig} style={{paddingTop: "100px"}}/>
        <WizModal visible={this.state.scoreVisable} footer={null}
           onOk={()=>this.setState({
            scoreVisable:false
           })}
           onCancel={()=>this.setState({
            scoreVisable:false
           })}
          >
          <LookPositionAuthState key ={new Date().getTime()}  record={this.state.lookRecord} />
        </WizModal>
      </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementPersonnelDetailList);
